import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { ToStringHelper } from 'src/app/helpers/ToStringHelper';
import { IGenericApiResponse } from 'src/app/models/common/GenericApiResponse';
import { RequestResultsType } from 'src/app/models/components/enums/RequestResultsType';
import { IDirectoryUser } from 'src/app/models/directory/users/DirectoryUser';
import { FilterRequestAge } from 'src/app/models/requests/enums/FilterRequestAge.enum';
import { IWorkflowRequest } from 'src/app/models/requests/WorkflowRequest';
import { GraphUserService } from 'src/app/services/graph/GraphUser.service';
import { WorkflowRequestService } from 'src/app/services/workflow/WorkflowRequestService';

@Component({
  selector: 'request-results',
  templateUrl: './request-results.component.html',
})
export class RequestResultsComponent implements OnInit {
  @Input() type: RequestResultsType;
  @Output() recordSelected = new EventEmitter<IWorkflowRequest>();

  filterRequestAge = FilterRequestAge.Last3Months;

  readonly filterRequestAgeOptions = Object.keys(FilterRequestAge)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      displayName: FilterRequestAge[key as keyof typeof FilterRequestAge],
      value: FilterRequestAge[key as keyof typeof FilterRequestAge],
    }))

  onFilterRequestAgeChange(event: any) {
    if (event.value) {
      this.filterRequestAge = event.value as FilterRequestAge;
      this.search();
    }
  }

  searchResults: IWorkflowRequest[];
  displayColumns: string[] = ['id', 'type', 'state', 'createDate'];

  screenMessage: string = '';
  isSearching: boolean = false;
  hasAdminRole: boolean = false;
  selectedUser: IDirectoryUser | undefined;

  constructor(
    private workflowService: WorkflowRequestService,
    private readonly userService: GraphUserService,
    private readonly authService: CalAngularService
  ) { }

  get RequestResultsType() {
    return RequestResultsType;
  }
  searchObserver = {
    next: (x: IGenericApiResponse<IWorkflowRequest[]>) => {
      this.searchResults = x.data;
    },
    error: (err: any) => {
      this.screenMessage = err.statusText;
      this.isSearching = false;
    },
    complete: () => {
      this.screenMessage = this.searchResults.length === 0 ? 'no results found' : '';
      this.isSearching = false;
    },
  };
  async ngOnInit(): Promise<void> {
    this.hasAdminRole = this.userService.CheckIsRequestReadAll(this.authService.cvxClaimsPrincipal);

    this.selectedUser = {
      id: this.authService.cvxClaimsPrincipal.objectId,
      displayName: this.authService.cvxClaimsPrincipal.name,
      userPrincipalName: this.authService.cvxClaimsPrincipal.userName,
    } as IDirectoryUser;

    this.selectedUser = ToStringHelper.overrideToString(this.selectedUser);

    this.search();
  }

  search() {
    this.screenMessage = '';
    this.isSearching = true;
    switch (this.type) {
      case RequestResultsType.Approver:
        // we don't support searching by approvers yet, so force to false to hide the requestor picker
        this.hasAdminRole = false;
        this.workflowService.GetByApprover(this.filterRequestAge).subscribe(this.searchObserver);
        break;
      case RequestResultsType.Requestor:
        this.workflowService.GetRequestsByRequestorId(this.selectedUser!.id, this.filterRequestAge).subscribe(this.searchObserver);
        break;
    }
  }

  selected(request: IWorkflowRequest) {
    this.recordSelected.emit(request);
  }
  selectedRequestorChanged(requestor: IDirectoryUser) {
    this.selectedUser = requestor;
    this.search();
  }
}